import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TicketsService } from 'src/app/services/tickets.service';

@Component({
  selector: 'app-info-menu-modal',
  templateUrl: './info-menu-modal.component.html',
  styleUrls: ['./info-menu-modal.component.scss'],
})
export class InfoMenuModalComponent implements OnInit {
  events: any = [];
  loading: any = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<InfoMenuModalComponent>,
    private ticketsService: TicketsService,
    public router: Router
  ) {}

  async ngOnInit() {
    (
      await this.ticketsService.getInfoMenuToUsedTicket(this.data.idMenu)
    ).subscribe((data) => {
      if (data.result) {
        this.loading = false;
        this.events = data.result;
      } else {
      }
    });
  }

  closeDialog(action: any) {
    this.dialogRef.close(action);
  }

  moveToEvent(id: any) {
    this.router.navigate(['/events/' + id]);
    this.closeDialog(false);
  }
}
